import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-跨部门跨平台",
  "use": "icon-跨部门跨平台-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-跨部门跨平台\">\r\n<path d=\"M37.7,108.7c0-7,6-12.7,13.3-12.7h46.2c-2.4-0.5-4.8-1.7-6.6-3.4l-31.6-30c-2.5-2.3-3.9-5.5-3.9-9c0-3.4,1.4-6.7,3.9-9\r\n\tl31.5-29.9c5.3-5,13.6-5,18.9,0L141,44.6c5.2,5,5.2,13,0,18l-31.5,29.9c-1.9,1.8-4.2,2.9-6.6,3.5h46.1c7.4,0,13.3,5.7,13.3,12.7\r\n\tv12.7h13.3c7.4,0,13.3,5.7,13.3,12.7v42.4c0,7-6,12.7-13.3,12.7h-44.5c-7.4,0-13.3-5.7-13.3-12.7V134c0-7,6-12.7,13.3-12.7H149\r\n\tv-12.7H51.1v12.7h17.8c7.4,0,13.3,5.7,13.3,12.7v42.4c0,7-6,12.7-13.3,12.7H24.4C17,189.1,11,183.4,11,176.4v-42.4\r\n\tc0-7,6-12.7,13.3-12.7h13.3L37.7,108.7L37.7,108.7z M68.9,134.1H24.4v42.4h44.5V134.1z M175.7,134.1h-44.5v42.4h44.5V134.1z\r\n\t M100,23.6l-31.5,30L100,83.5l31.5-29.9L100,23.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/跨部门跨平台.svg
// module id = 2JXX
// module chunks = 15